export default __webpack_public_path__ + "static/media/hn.5683217c.svg";